export enum BackgroundRequests {
  PRODUCTS_GENERATION = 'products_generation',
  PRODUCTS_CSV_LIST = 'products_csv_list',
}
